export default __webpack_public_path__ + "_/images/promo_action/instructions/image5-310edf384c3e6ac98efd917362598923329147f653de76c26c21b2a005732017.png";